import $i from "~/i18n";
export const getPostDetail = async({ commit }, payload) => {
    try {
        let { data } = await axios.post("/blog/get-post-detail", {
            Id: parseInt(payload.id)
        });
        if (data.state != 200) return;
        commit("SET_DATA", { data: data.detail[0], id: "post" });
    } catch (error) {
        console.log(error);
    }
};
export const clearBlog = async({ commit }) => {
    commit("SET_DATA", { data: null, id: "post" });
    let form = {
        img: '',
        title: "",
        content: "",
        imgSrc: "",
        description: "",
        subcategory_id: null,
        pdf: null,
    }
    commit("SET_DATA", { data: form, id: "form" });
};

export const add = async({ commit, state }, payload) => {
    try {
        let { data } = await axios.post("/blog/new-post", payload, {
            onUploadProgress: function(progressEvent) {
                state.uploadPercentage = parseInt(
                    Math.round((progressEvent.loaded * 100) / progressEvent.total)
                );
            }
        }, {
            "Content-Type": "multipart/form-data"
        });
        if (data.state != 200) {
            commit(
                "notifications/error", { message: JSON.stringify(data.message), title: "خطا" }, { root: true }
            );
            return false
        } else {
            commit(
                "notifications/success", { message: $i.t("message.request.done"), title: "" }, { root: true }
            );
            return true
        }
    } catch (error) {
        console.log(error);
    }
};
export const update = async({ commit }, payload) => {
    try {
        let { data } = await axios.post("/blog/update-post", payload);
        if (data.state != 200) {
            if (data.message) {
                for (let index = 0; index < data.message.length; index++) {
                    const element = data.message[index];
                    commit("notifications/error", { message: Object.keys(element) + ' ' + Object.values(element), title: "مشکلی است." }, { root: true })
                }
            }
            return false
        };
        commit(
            "notifications/success", { message: $i.t("message.request.done"), title: "" }, { root: true }
        );
        return true
    } catch (error) {
        console.log(error);
    }
};
export const updateImage = async(context, payload) => {
    try {
        let { data } = await axios.post("/blog/update-img-post", payload, {
            "Content-Type": "multipart/form-data"
        });
        if (data.state != 200) return data;
        context.commit(
            "notifications/success", { message: $i.t("message.request.done"), title: "" }, { root: true }
        );
    } catch (error) {
        console.log(error);
    }
};
export const inactive = async(context, payload) => {
    try {
        let { data } = await axios.post("/blog/inactive-post", {
            id: payload.id
        });
        if (data.state != 200) return;
        context.commit(
            "notifications/success", { message: $i.t("message.request.done"), title: "" }, { root: true }
        );
    } catch (error) {
        console.log(error);
    }
};
export const getPosts = async({ commit }, payload) => {
    try {
        let { data } = await axios.post("/blog/get-posts", {
            page_num: payload.page
        });
        if (data.state != 200) return;
        commit("SET_DATA", { data: data.posts, id: "posts" });
        // console.log(data);
    } catch (error) {
        console.log(error);
    }
};
export const getAllPosts = async({ commit }, payload) => {
    try {
        let { data } = await axios.post("/blog/get-posts-su", {
            page_num: payload.page
        });
        if (data.state != 200) return;
        commit("SET_DATA", { data: data.posts, id: "allPosts" });
        return  data
    } catch (error) {
        console.log(error);
    }
};
export const setStatus = async({ commit }, payload) => {
    try {
        let { data } = await axios.post("/blog/edit-post-status-su", {
            id: payload.id,
            status: payload.status,
        });
        if (data.state != 200) {
            commit(
                "notifications/error", { message: JSON.stringify(data.message), title: "خطا" }, { root: true }
            );
            return false
        } else {
            commit(
                "notifications/success", { message: $i.t("message.request.done"), title: "" }, { root: true }
            );
            return true
        }
    } catch (error) {
        console.log(error);
    }
};
export const remove = async({ commit }, payload) => {
    try {
        let { data } = await axios.post("/blog/delete-post", {
            id: payload.id,
        });
        if (data.state != 200) {
            commit(
                "notifications/error", { message: JSON.stringify(data.message), title: "خطا" }, { root: true }
            );
            return false
        } else {
            commit(
                "notifications/success", { message: $i.t("message.request.done"), title: "" }, { root: true }
            );
            return true
        }
    } catch (error) {
        console.log(error);
    }
};
export const getDetails = async({ commit, rootState }, payload) => {
    try {
        let { data } = await axios.post("/blog/get-post-detail", {
            id: payload.id,
            uuid: ""
        });
        if (data.state != 200) return;
        let res = data.detail[0]
        if (payload.isImage) {
            commit("SET_DATA_CHILD", { data: data.detail[0].img, id: "form", child: 'img' });

        } else {
            commit("SET_DATA", { data: data.detail[0], id: "form" });
        }

    } catch (error) {
        console.log(error);
    }
};
export const getMyPosts = async({ commit }, payload) => {
    try {
        let { data } = await axios.post("/blog/get-my-posts", {
            page_num: payload.page
        });
        if (data.state != 200) return;
        commit("SET_DATA", { data: data.posts, id: "posts" });
        return  data
    } catch (error) {
        console.log(error);
    }
};




// WEBPACK FOOTER //
// ./src/store/modules/dashboard/blog/actions.js